import { useCallback } from 'react';

export interface IUseInfiniteScrollParams {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => Promise<unknown>;
  threshold?: number;
}

const useInfiniteScroll = ({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  threshold = 0.75,
}: IUseInfiniteScrollParams) => {
  return useCallback(
    (event: React.UIEvent<HTMLElement>) => {
      const target = event.currentTarget;
      const { scrollTop, clientHeight, scrollHeight } = target;

      const scrollPosition = scrollTop + clientHeight;
      const triggerThreshold = scrollHeight * threshold;

      if (scrollPosition >= triggerThreshold && hasNextPage && !isFetchingNextPage) {
        void fetchNextPage();
      }
    },
    [hasNextPage, isFetchingNextPage, fetchNextPage, threshold],
  );
};

export default useInfiniteScroll;
